<template>
  <div class="my-viewer">
    <div v-show="sortCtrl" class="viewer-sort">
      <ul :id="unitKey" :style="{'width':(imgData.length*30+imgData.length)+'px','transform':`translateX(${screenWidth*0.5-imgActiveIndex*31-15}px)`}">
        <li v-for="(item,index) in imgData" :key="index" :class="index==imgActiveIndex?'active-li':''">
          <img :src="item.url || ''" :alt="item.name" @click="viewImg(index)">
        </li>
      </ul>
    </div>
    <viewer v-if="imgData.length!=0" :options="options" @inited="inited">
      <div v-for="(itemAttach,itemIndex) in imgData" v-show="itemIndex < (maxShowLength || 100)" :key="itemIndex" class="detailed-box">
        <template v-if="maxShowLimit && imgData.length>maxShowLimit && itemIndex === (maxShowLimit-1)">
          <div class="viewer-position" @click="viewImg(itemIndex)">
            <span class="viewer-number" :data-source="itemAttach.url" :alt="itemAttach.fileName">{{ imgData.length }}张</span>
            <img :src="itemAttach.url" :style="{width:(width || 80)+'px',height:(height || 80)+'px'}" :data-source="itemAttach.url" :alt="itemAttach.fileName">
          </div>
        </template>
        <template v-else>
          <img :src="itemAttach.url" :style="{width:(width || 80)+'px',height:(height || 80)+'px'}" :data-source="itemAttach.url" :alt="itemAttach.fileName" />
        </template>
      </div>
    </viewer>
  </div>
</template>
<script>
export default {
  components: {},
  props: [
    'listData', // data为数据(arr)
    'imgId', // 图片id字段(可传可不传，默认‘id’)
    'isSort', // 是否展示左侧排序模块(bool)(可传可不传，默认为不展示，传true则会展示)
    'width', // width为展示小图片的宽度(num)(可传可不传，默认为80)
    'height', // height为展示小图片的高度(num)(可传可不传，默认为80)
    'clueId',
    'maxShowLength', // 最大展示图片数
    'maxShowLimit'// 最大展示图片数
  ],
  data() {
    return {
      screenWidth: '',
      unitKey: '',
      imgData: [],
      imgActiveIndex: '', // 当前查看图片的index
      opera: 'add', // 操作 add代表添加操作 remove代表移除操作
      sortCtrl: false, // 左侧排序选择框控制是否显示
      options: { // v-viewer配置 具体api 中文文档https://mirari.cc/categories/%E9%A1%B9%E7%9B%AE/Vue/ 原作者英文文档https://github.com/fengyuanchen/viewerjs#methods
        url: 'data-source',
        view: function(currentItem) {
          const t = this
          setTimeout(function() {
            t.viewer.options.title(t.viewer.image, t.viewer.imageData, t.viewer.index)
          }, 50)
          return currentItem
        },
        title: (image, imageData, index) => {
          if (index || index == 0) {
            this.imgActiveIndex = index
          }
          return `<span style="display:none;" id="index"></span>${image.alt}(${imageData.naturalWidth} × ${imageData.naturalHeight})`
        },
        show: (data) => {
          this.sortCtrl = true
          if (this.isSort) {
            this.renderDrag()
          }
        },
        hide: () => {
          this.sortCtrl = false
        },
        className: 'text-viewer-img'
      },
      // 已经勾选的图片
      chooseImg: []
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.unitKey = Math.floor(Math.random() * 10000) + 'darg'
    this.screenWidth = document.body.clientWidth
    if (this.listData) {
      this.imgData = this.listData.filter((item, index) => {
        return item.mediaType.indexOf('image') != -1
      })
    } else {
      this.imgData = []
    }
  },
  updated() {},
  methods: {
    // 监听viewer组件
    inited(viewer) {
      this.$viewer = viewer
    },
    renderDrag() {
      const t = this
      var $ul = document.getElementById(this.unitKey)
      new Sortable($ul, {
        onUpdate: function(event) {
          const oldObj = t.imgData[event.oldIndex]
          const newObj = t.imgData[event.newIndex]
          const newIndex = event.newIndex
          const oldIndex = event.oldIndex
          const $li = $ul.children[newIndex]
          const $oldLi = $ul.children[oldIndex]
          // 先删除移动的节点
          $ul.removeChild($li)
          // 再插入移动的节点到原有节点，还原了移动的操作
          if (newIndex > oldIndex) {
            $ul.insertBefore($li, $oldLi)
          } else {
            $ul.insertBefore($li, $oldLi.nextSibling)
          }
          // 更新items数组
          t.$set(t.imgData, event.oldIndex, newObj)
          t.$set(t.imgData, event.newIndex, oldObj)
        },
        onEnd(event) {
          const oldObj = t.imgData[event.oldIndex]
          const newObj = t.imgData[event.newIndex]
          setTimeout(function() {
            t.$viewer.update()
            t.viewImg(event.newIndex)
          }, 100)
          t.loadSort(newObj.id, event.newIndex)
        },
        animation: 150
      })
    },
    viewImg(index) {
      this.$viewer.view(index)
    },
    // 拖拽结束
    loadSort(id, index) {
      const url = '/business/clue/picture/sort'
      const ajaxData = {
        clueId: this.clueId,
        attachId: id,
        sort: index + 1
      }
      this.$patch(url, ajaxData).then(res => {
        if (res.code == 0) {}
      })
    }
  }
}
</script>
<style lang="scss">
.text-viewer-img{
    .viewer-footer{
        .viewer-navbar{
            opacity: 0;
        }
    }
}
.viewer-position{
    display: inline-block;
    height: 80px;
    width: 80px;
    position: relative;
    img{
        background-color: rgba(0,0,0,.6);
    }
}
.viewer-number{
    display: inline;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}
</style>
<style scoped lang="sass">
@import "./myViewer"
</style>



// WEBPACK FOOTER //
// src/components/common/myViewer/myViewer.vue